// extracted by mini-css-extract-plugin
export default {"eyeIcon":"style_eyeIcon__vnsss"};